import { defineMessages } from "react-intl";

export const deprecationBannerMessages = defineMessages({
  message: {
    id: "H9gOMX",
    defaultMessage:
      "This Saleor version is deprecated and will be automatically upgraded on {date}.",
    description: "deprecation banner shown in the sidebar",
  },
});
